import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import {AttributeDiv} from './layout/InputCol';
import {Col} from 'react-bootstrap';
import {flowRight as compose} from 'lodash';
import {withTranslation} from 'react-i18next';
import Tooltip from './Tooltip';


const UnitDiv = styled.div`
  width: 10%;
  height: 36px;
  font-weight: bold;
  color: #565484;
  border: 0.5px solid #d0d1df;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 0;
`;

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  width: 90%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: white;
`;


const AmountInput = ({t, amount, name, onChange, show, textInputRequired}) => {
  return (
    <Col xs={12}>
      <label>
        <AttributeDiv>{`${t('amount')} : `}</AttributeDiv>
        <FlexDiv>
          <Input
            type="number"
            step="1"
            value={amount}
            name={name}
            onChange={onChange}
          />
          <UnitDiv>€</UnitDiv>
        </FlexDiv>
      </label>
      <Tooltip show={show} color={'red'}>
        {textInputRequired || t('requiredField')}
      </Tooltip>
    </Col>
  );
};

AmountInput.propTypes = {
  t: PropTypes.func.isRequired,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  show: PropTypes.bool,
  textInputRequired: PropTypes.string,
};

AmountInput.defaultProps = {
  name: 'amount',
  show: false,
};

export default compose(
  withTranslation('common'),
)(AmountInput);
